import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import RawMaterialArticlesComponent from './raw-material-articles.component';

let RawMaterialArticlesModule = angular
  .module('RawMaterialArticles', [
    uiRouter
  ])
  .component('rawmaterialarticles', RawMaterialArticlesComponent)
  .config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('rawMaterialArticles', {
      url: '/raw-materials/:id/articles',
      data: {
        authRequired: true
      },
      params: {
        material: null
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'rawmaterialarticles'
        }
      },
      resolve: {
        material: ($transition$) => {
          'ngInject';
          return $transition$.params().material;
        }
      }
    });
  })
  .name;

export default RawMaterialArticlesModule;



// WEBPACK FOOTER //
// ./src/app/pages/raw-material-articles/raw-material-articles.module.js